import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgInformation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M1.66669 16C1.66669 8.08391 8.08394 1.66666 16 1.66666C23.9162 1.66666 30.3334 8.08391 30.3334 16C30.3334 23.9161 23.9162 30.3333 16 30.3333C8.08394 30.3333 1.66669 23.9161 1.66669 16ZM16 8.99999C15.0795 8.99999 14.3334 9.74618 14.3334 10.6667C14.3334 11.5871 15.0795 12.3333 16 12.3333C16.9206 12.3333 17.6667 11.5871 17.6667 10.6667C17.6667 9.74618 16.9206 8.99999 16 8.99999ZM17 14.6667C17 14.1144 16.5523 13.6667 16 13.6667C15.4478 13.6667 15 14.1144 15 14.6667V21.3333C15 21.8856 15.4478 22.3333 16 22.3333C16.5523 22.3333 17 21.8856 17 21.3333V14.6667Z",
		fill: "currentColor"
	})
});
export default SvgInformation;
